import Header from "@/components/Header";
import Footer from "@/components/Footer";
import Breadcrumbs from "@/components/Breadcrumbs";
import { Helmet } from "react-helmet-async";
import { SITE_NAME, SITE_URL } from "@/lib/seo-schemas";

const PolitiqueConfidentialite = () => {
  const breadcrumbItems = [
    { label: "Accueil", href: "/" },
    { label: "Politique de confidentialité", href: "/politique-de-confidentialite" },
  ];

  return (
    <>
      <Helmet>
        <title>Politique de Confidentialité | {SITE_NAME}</title>
        <meta name="description" content={`Politique de confidentialité de ${SITE_NAME}. Découvrez comment nous collectons, utilisons et protégeons vos données personnelles.`} />
        <meta name="robots" content="index, follow" />
        <link rel="canonical" href={`${SITE_URL}/politique-de-confidentialite`} />
      </Helmet>

      <div className="min-h-screen bg-background">
        <Header />
        <Breadcrumbs items={breadcrumbItems} />

        <main className="max-w-4xl mx-auto px-4 py-16">
          <h1 className="text-3xl md:text-4xl font-black text-foreground mb-8">Politique de Confidentialité</h1>
          <p className="text-sm text-muted-foreground mb-8">Dernière mise à jour : 21 février 2026</p>

          <div className="space-y-8 text-muted-foreground leading-relaxed">
            <section>
              <h2 className="text-xl font-bold text-foreground mb-3">1. Responsable du traitement</h2>
              <p>{SITE_NAME} — contact@roidustreaming.fr</p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-foreground mb-3">2. Données collectées</h2>
              <p>Nous collectons uniquement les données nécessaires au fonctionnement du service :</p>
              <ul className="list-disc pl-6 mt-2 space-y-1">
                <li>Adresse email (lors de l'inscription ou demande de test)</li>
                <li>Données de navigation anonymisées (pages consultées, appareil utilisé)</li>
                <li>Données de paiement (traitées exclusivement par Stripe, jamais stockées chez nous)</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-bold text-foreground mb-3">3. Finalités du traitement</h2>
              <ul className="list-disc pl-6 space-y-1">
                <li>Fournir et gérer votre abonnement IPTV</li>
                <li>Envoyer vos identifiants de connexion</li>
                <li>Répondre à vos demandes de support</li>
                <li>Améliorer nos services et l'expérience utilisateur</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-bold text-foreground mb-3">4. Durée de conservation</h2>
              <p>Vos données sont conservées pendant la durée de votre abonnement et jusqu'à 12 mois après sa fin pour des raisons de support technique.</p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-foreground mb-3">5. Vos droits</h2>
              <p>Conformément au RGPD, vous disposez d'un droit d'accès, de rectification, de suppression et de portabilité de vos données. Contactez-nous à contact@roidustreaming.fr pour exercer vos droits.</p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-foreground mb-3">6. Cookies</h2>
              <p>Nous utilisons des cookies techniques nécessaires au fonctionnement du site. Aucun cookie de traçage publicitaire n'est utilisé.</p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-foreground mb-3">7. Sécurité</h2>
              <p>Nous mettons en œuvre des mesures de sécurité adaptées (HTTPS, chiffrement, accès restreint) pour protéger vos données personnelles.</p>
            </section>
          </div>
        </main>

        <Footer />
      </div>
    </>
  );
};

export default PolitiqueConfidentialite;
